export default 'icon--close';